<di-search
           [title]="config.title"
           searchPlaceholder="Search"
           [columns]="columns"
           [pageDTO]="pageDTO">

</di-search>